import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AmenitiesLookup } from 'src/app/features/restaurants/models/List.Restaurant';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { LookupsService } from 'src/app/services/lookups.service';
import Swal from 'sweetalert2';

export interface DialogData {
  selectedItems: any[],
  restaurantId: number
}

@Component({
  selector: 'app-amenities-form',
  templateUrl: './amenities-form.component.html'
})
export class AmenitiesFormComponent extends DirtyComponent implements OnInit {
  dataLoading = false;
  pageIndex = 0;
  pageCount = 0;
  recordsData: AmenitiesLookup[] = []
  isSubmitted = false;
  selectedAmenities: any[] = []

  amenities: AmenitiesLookup[] = []
  amenitiesCopy: any = []

  lang = localStorage.getItem('language') || 'en';
  searchText?: any;
  constructor(
    private service: LookupsService,
    private restaurantService: RestaurantService,
    override dialogRef: MatDialogRef<AmenitiesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    super(translate)
  }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.GetAmenities();

    this.selectedAmenities = JSON.parse(JSON.stringify(this.data.selectedItems));
    this.amenitiesCopy = JSON.stringify(this.selectedAmenities);
  }

  GetAmenities() {
    this.dataLoading = true;
    this.service.GetAllAmenities().subscribe((data: any) => {
      this.dataLoading = false;
      this.amenities = data
      this.amenities.map((item: AmenitiesLookup) => {
        let findSelected = this.selectedAmenities.find((x: AmenitiesLookup) => x.id == item.id);
        item.isSelected = findSelected ? true : false
        item.canDelete = findSelected ? findSelected.canDelete : true
      })
    })
  }
  override canDeactivate(): boolean {
    return JSON.stringify(this.selectedAmenities).length !== this.amenitiesCopy.length || this.searchText
  };


  selected(event?: any, item?: any) {
    if (event.checked) {
      this.selectedAmenities.push(item)
    } else {
      this.selectedAmenities.splice(item, 1)
    }
  }
  isAllHidden() {
    return this.amenities.every(item => this.hideOption(item));
  }
  hideOption(item: any) {
    return new RegExp(this.searchText, 'i').test(item.title_EN) === false && new RegExp(this.searchText, 'i').test(item.title_AR) === false
  }

  hasRecordsData() {
    return (
      !this.isAllHidden() &&
      this.amenities
      && this.amenities.length
      && this.data.selectedItems.length != this.amenities.length
    )
  }

  saveRecord() {
    this.isSubmitted = true;
    if (JSON.stringify(this.selectedAmenities).length !== this.amenitiesCopy.length) {
      this.dataLoading = true;

    let amenities =
      this.amenities.filter((item: any) => item.isSelected).map((x: any) => {
        return {
          amenitiesId: x.id
        }
      })

    let data = {
      amenities,
      restaurantId: this.data.restaurantId,
    };


    this.restaurantService.SaveRestaurantAmenities(data).subscribe(() => {
      this.dataLoading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Success'),
        text: this.translate.instant('swalMsg.updatedsuccessfully'),
        icon: 'success',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      });
      this.dialogRef.close(true);
    }, error => {
      this.dataLoading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    });
    } else {
      Swal.fire({
        title: this.translate.instant('swalMsg.Warning'),
        text: this.translate.instant('swalMsg.noChangesHappens'),
        icon: 'warning',
        confirmButtonText: this.translate.instant('swalMsg.Ok')
      });
      this.dialogRef.close(true);
    }
   
  }


}
